<template>
    <div class="custom-textarea">
        <textarea ref="textArea" :value="value" :maxlength="maxlength" @input="inputHandle"></textarea>
        <span>{{ count }}</span>
    </div>
</template>

<script>
import CustomTextarea from './CustomTextarea.js'
export default CustomTextarea
</script>

<style lang="scss" scoped>
@import "./CustomTextarea.scss";
</style>


// WEBPACK FOOTER //
// src/components/CustomTextarea/CustomTextarea.vue